<template>
    <div class="sidebar-item">
        <button type="button" class="sidebar-element-icon"
                :disabled="isDisabled"
                @click="setFormClicked"
                v-if="element.optionalAttribute.actionType === 'form'">
            <img :alt="element.customDescription" :title="element.customDescription" class="img-fluid"
                 :src="routeImage + iconSidebar" />
        </button>
        <button type="button" class="sidebar-element-icon"
                @click="handleHyperLink(element)"
                v-if="element.optionalAttribute.actionType === 'hyperlink'"
                :disabled="isDisabled">
            <img :alt="element.customDescription" :title="element.customDescription" class="img-fluid"
                 :src="routeImage + iconSidebar" />
        </button>
        <button type="button" class="sidebar-element-icon"
                :disabled="isDisabled"
                @click="toggleShareVideo"
                v-if="element.optionalAttribute.actionType === 'social'">
            <img :alt="element.customDescription" :title="element.customDescription" class="img-fluid"
                 :src="routeImage + iconSidebar" />
        </button>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import { downloadPDF } from "@/playerVue3/services/download-service";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS
const props = defineProps({
    element: {
        type: Object,
        required: true
    },
});

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const iconSidebar = computed(() => {
    if (store.getPathLocalOrServer !== '') {
        if (props.element.customIcon) {
            return props.element.customIcon;
        }
        return props.element.optionalAttributeIcon.iconSource;
    }
    return '';
});

const isDisabled = computed(() => {
    // Comentado para que no se cierre el sidebar al dar click en un elemento consultar con Javier
    // const formLateralStatus = false; //store.getFormClickedFromToolbox;
    // const modalSocialShareStatus = store.getShareVideoStatus;
    // const hotspotStatus = store.getActiveHotspot;

    // return !!(formLateralStatus || modalSocialShareStatus || hotspotStatus);
    return false;
});

const routeImage = computed(() => {
    if (store.getPathLocalOrServer !== '') {
        return store.getPathLocalOrServer + 'images_variables/';
    }
    return '';
});

// METHODS
const handleHyperLink = async (element) => {
    if (element.customAction !== '' || element.fieldExcelId !== null) {
        const weblinkID = store.getWeblinkID;
        let urlHyperlink = element.customAction;
        if (element.fieldExcelId !== null && weblinkID > 0) {
            const variableValue = store.getDataVariableById(element.fieldExcelId);
            if (variableValue.length > 0) {
                urlHyperlink = variableValue[0].description;
            }
        }
        if (urlHyperlink != '') {
            const pathFile = store.getPathLocalOrServer;
            const extFile = urlHyperlink.substring(urlHyperlink.lastIndexOf(".")+1)
            const validExt = [ 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv' ];
            let folderFile = 'images_variables';
            if (validExt.indexOf(extFile) > -1) {
                folderFile = 'files_variables';
            }
            switch (parseInt(element.permitDownload)) {
                case 0:
                    if (isValidUrl(urlHyperlink)) {
                        window.open(urlHyperlink);
                    } else {
                        window.open(pathFile + folderFile + "/" + urlHyperlink);
                    }
                    break;
                case 1:
                    const isPdf = urlHyperlink.includes('.pdf');
                    const hasHTTP = urlHyperlink.includes('http');
                    if (isPdf && !hasHTTP) {
                        await downloadPDF(pathFile + folderFile + "/" + urlHyperlink);
                    } else if (isPdf && hasHTTP) {
                        await downloadPDF(urlHyperlink);
                    } else {
                        if (isValidUrl(urlHyperlink)) {
                            window.open(urlHyperlink);
                        } else {
                            window.open(pathFile + folderFile + "/" + urlHyperlink);
                        }
                    }
                    break;
                default:
                    if (isValidUrl(urlHyperlink)) {
                        window.open(urlHyperlink);
                    } else {
                        window.open(pathFile + folderFile + "/" + urlHyperlink);
                    }
                    break;
            }
        }
    }
};

const isValidUrl = (string) => {
    if (string && string.includes('mailto')) {
        return true;
    } else {
        if (string && string.length > 1 && string.slice(0, 2) === '//') {
            string = 'http:' + string;
        }
        try {
            let url = new URL(string);
            //return url.hostname && /^(http|https|ftp):\/\/[^ "]+$/.test(url.href) ? true : false;
            return !!(url.hostname && /^(http|https|ftp):\/\/[^ "]+$/.test(url.href));
        } catch (_) {
            return false;
        }
    }
};

const setFormClicked = () => {
    if(store.getShareVideoStatus) {
        store.setShareVideoStatus();
    }
    store.getPlayer.pause();
    store.setFormClickedFromSidebarData({data: props.element});
};

const toggleShareVideo = () => {
    if(store.getFormClickedFromSidebarData) {
        store.setFormClickedFromSidebarData({data: null});
    }
    store.getPlayer.pause();
    store.setShareVideoStatus();
};

// LIFECYCLE HOOKS
</script>
